var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbnailImgwithoutword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 814,
    height: 964,
    viewBox: "0 0 814 964",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1702_5349)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.5 -0.5C270.833 -0.5 542.167 -0.5 813.5 -0.5C813.5 320.833 813.5 642.167 813.5 963.5C542.167 963.5 270.833 963.5 -0.5 963.5C-0.5 642.167 -0.5 320.833 -0.5 -0.5Z",
    fill: "#F5DAD0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.972 635.102C421.657 635.102 392.343 635.102 363.028 635.102C304.019 635.102 245.01 635.102 186 635.102C186 429.901 186 224.701 186 19.5C333.333 19.5 480.667 19.5 628 19.5C628 224.701 628 429.901 628 635.102C568.99 635.102 509.981 635.102 450.972 635.102Z",
    fill: "#FEFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.028 635.102C392.343 635.102 421.657 635.102 450.972 635.102C450.972 693.73 450.972 752.36 450.972 810.988C421.657 810.988 392.343 810.988 363.028 810.988C363.028 752.36 363.028 693.73 363.028 635.102Z",
    fill: "#EE625E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1702_5349"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 814,
    height: 964,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnailImgwithoutword);
export default __webpack_public_path__ + "static/media/Thumbnail Img without word.fd088ab74a2ceb9421bf08babac9f46f.svg";
export { ForwardRef as ReactComponent };